// tslint:disable:max-line-length

import React from 'react';

export const ActionHide = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M14,0.6l-0.7,0.7l-12,12L0.6,14L2,15.4l0.7-0.7l12-12L15.4,2C15.4,2,14,0.6,14,0.6z M8.1,2C3,2,0,8,0,8s0.8,1.5,2.2,3l2-2 C4.1,8.7,4,8.4,4,8c0-2.2,1.8-4,4-4c0.4,0,0.7,0.1,1,0.2l1.6-1.6C9.8,2.2,9,2,8.1,2L8.1,2z M13.8,5l-2,2C11.9,7.3,12,7.6,12,8 c0,2.2-1.8,4-4,4c-0.4,0-0.7-0.1-1-0.2l-1.6,1.6C6.2,13.8,7.1,14,8.1,14C13,14,16,8,16,8S15.2,6.5,13.8,5L13.8,5z" />
    </svg>
  );
};
